/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M1.5716 9.5928C2.1405 5.0306 6.0335 1.5 10.75 1.5a.75.75 0 0 0 0-1.5C5.2674 0 .7445 4.1036.0831 9.4072a.75.75 0 0 0 1.4885.1856ZM15.3191 1.0167a.75.75 0 0 0-.6383 1.3575c2.8119 1.322 4.8484 4.0178 5.2476 7.2186a.75.75 0 0 0 .837.6514.7499.7499 0 0 0 .6514-.837c-.4644-3.725-2.8327-6.8553-6.0977-8.3905ZM1.854 13.2942a.75.75 0 0 0-1.4423.4116C1.6957 18.205 5.837 21.5 10.75 21.5a.75.75 0 0 0 0-1.5c-4.2253 0-7.7908-2.8337-8.896-6.7058ZM19.5 19.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.75 11c-1.4497 0-2.625 1.1753-2.625 2.625V15.5H15c-.8284 0-1.5.6716-1.5 1.5v5.5c0 .8284.6716 1.5 1.5 1.5h7.5c.8284 0 1.5-.6716 1.5-1.5V17c0-.8284-.6716-1.5-1.5-1.5h-1.125v-1.875l-.0039-.144C21.2963 12.0982 20.1514 11 18.75 11Zm1.125 4.5v-1.8548l-.0027-.0993c-.0399-.5837-.5276-1.0459-1.1223-1.0459-.6213 0-1.125.5037-1.125 1.125V15.5h2.25ZM15 22.5h7.5V17H15v5.5Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M10.25 5a.75.75 0 0 1 .75-.75c2.9401 0 5.4394 1.8794 6.3657 4.5a.75.75 0 0 1-1.4143.5c-.7211-2.0402-2.6667-3.5-4.9514-3.5a.75.75 0 0 1-.75-.75ZM7.8772 5.8212a.75.75 0 0 1-.1246 1.0533C6.5316 7.8371 5.75 9.3271 5.75 11c0 2.8995 2.3505 5.25 5.25 5.25a.75.75 0 0 1 0 1.5c-3.728 0-6.75-3.0221-6.75-6.75 0-2.1518 1.0077-4.0686 2.5739-5.3034a.75.75 0 0 1 1.0533.1246Z"
    />
    <path
      fill="currentColor"
      d="M12.1642 11.455c-.2513.643-.9762.9605-1.6192.7092a.75.75 0 1 0-.546 1.3971c1.4145.5529 3.0094-.1457 3.5623-1.5602.5529-1.4146-.1456-3.0095-1.5602-3.5624-1.4146-.553-3.0095.1456-3.5624 1.5602a.75.75 0 1 0 1.397.546c.2514-.643.9764-.9605 1.6193-.7091.643.2513.9606.9762.7092 1.6192Z"
    />
  </React.Fragment>,
  'MenuIdentityProviders'
);
